import "../Home-page.scss"; // Assuming shared styles
import { Grid, Typography, Link } from "@mui/material";
import React from "react";

function AboutPage() {
  const contactEmail = "apps@contractsq.com"; // Using email from other docs

  return (
    <div style={{ justifyContent: "center", display: "flex", width: "100%" }}>
      <div style={{ maxWidth: "960px", padding: "40px 20px", width: "100%" }}>
        {" "}
        {/* Added more padding */}
        <Grid container spacing={4} justifyContent="center">
          {" "}
          {/* Increased spacing */}
          <Grid item xs={12} md={10}>
            <div style={{ color: "#FFFFFF", textAlign: "left" }}>
              <Typography
                variant="h4"
                gutterBottom
                style={{ textAlign: "center", marginBottom: "32px" }}
              >
                About Logofy
              </Typography>

              <Typography variant="body1" paragraph>
                Logofy harnesses the power of artificial intelligence to help
                you create stunning, unique logos for your brand in minutes.
                Whether you're starting a new business, launching a project, or
                rebranding, Logofy provides the tools you need to design a
                professional logo effortlessly.
              </Typography>

              <Typography variant="body1" paragraph>
                Our mission is to make great design accessible to everyone.
                Describe your vision, explore different styles, customize the
                results, and export high-quality assets ready for use anywhere.
              </Typography>

              <Typography
                variant="h5"
                gutterBottom
                style={{ marginTop: "40px", marginBottom: "20px" }}
              >
                Contact Us
              </Typography>

              <Typography variant="body1" paragraph>
                Have questions, feedback, or need support? We'd love to hear
                from you!
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <Typography variant="body1">
                    Email:{" "}
                    <Link
                      href={`mailto:${contactEmail}`}
                      style={{ color: "#BB86FC", textDecoration: "underline" }}
                    >
                      {contactEmail}
                    </Link>
                  </Typography>
                </Grid>
              </Grid>

              {/* Add other contact methods/social links here if needed */}
              {/* Example:
              <Grid container spacing={2} alignItems="center" style={{ marginTop: '16px' }}>
                 <Grid item>
                   <TwitterIcon style={{ color: '#BB86FC' }} />
                 </Grid>
                 <Grid item>
                   <Typography variant="body1">
                     Twitter: {" "}
                     <Link href="https://twitter.com/yourhandle" target="_blank" rel="noopener noreferrer" style={{ color: '#BB86FC', textDecoration: 'underline' }}>
                       @yourhandle
                     </Link>
                   </Typography>
                 </Grid>
               </Grid>
              */}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default AboutPage;
